import React from 'react';
import styled from 'styled-components';
import { Form, Tabs } from 'tdesign-react';
import { connect } from 'react-redux';
import CodeMirrorLight from '@/components/CodeMirrorLight';
import { codeTypeOptions } from '@/utils/constant';

const { FormItem } = Form;

function Code() {
  return (
    <Root>
      <FormItem
        labelWidth={60}
        style={{ fontWeight: 'bold', fontSize: 16 }}
        label='脚本编辑'
        labelAlign='top'
        name='type'
        initialData={codeTypeOptions[0].value}
      >
        <Tabs style={{ width: '100%' }} list={codeTypeOptions} />
      </FormItem>
      <FormItem shouldUpdate={(prev, next) => prev.type !== next.type}>
        {({ getFieldValue }) => {
          const type = codeTypeOptions.find((item) => item.value === getFieldValue('type'))?.type;
          return (
            <FormItem name='scriptContent'>
              <CodeMirrorLight type={type} />
            </FormItem>
          );
        }}
      </FormItem>
    </Root>
  );
}

export default connect((state) => ({
  clientWidth: state.layout.clientWidth,
  clientHeight: state.layout.clientHeight,
}))(Code);

const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
  .code-mirror-light {
    margin-top: -10px;
  }
  .cm-editor {
    height: calc(100vh - 330px);
  }
`;
